// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';
import { ProjectVO } from './project.vo';
import { ErrorInfoVO } from '@shared/vo/error-info.vo';
import { DirectPrintingData } from '@project/components/request/project-request-price-calculation/price-calculation.helper';

@JsonObject('PriceCalculationRequestProjectVO')
export class PriceCalculationRequestProjectVO {

  @JsonProperty('projectId', 'Number')
  public projectId: number = undefined;

  @JsonProperty('projectVersion', 'Number')
  public projectVersion: number = undefined;

  @JsonProperty('projectWidth', 'Number')
  public projectWidth: number = undefined;

  @JsonProperty('labelCount', 'Number')
  public labelCount: number = undefined;

  @JsonProperty('notDefaultLabelCount', 'Number')
  public notDefaultLabelCount: number = undefined;

  @JsonProperty('directPrintingData', '[DirectPrintingData]')
  public directPrintingData: DirectPrintingData[] = undefined;

  @JsonProperty('brokenCodingFinger', 'Number')
  public brokenCodingFinger: number = undefined;
}

@JsonObject('PriceCalculationRequestVO')
export class PriceCalculationRequestVO {

    @JsonProperty('projectId', 'Number')
    public userId: number = undefined;

    @JsonProperty('locale', 'String')
    public locale: string = undefined;

    @JsonProperty('userAddressNumber', 'String')
    public userAddressNumber: string = undefined;

    @JsonProperty('userSalesOrganisation', 'String')
    public userSalesOrganisation: string = undefined;

    @JsonProperty('sapProjectNumber', 'String')
    public sapProjectNumber: string = undefined;

    @JsonProperty('receiverMail', 'String')
    public receiverMail: string = undefined;

    @JsonProperty('totalDemand', 'Number')
    public totalDemand: number = undefined;

    @JsonProperty('batchSize', 'Number')
    public batchSize: number = undefined;

    @JsonProperty('deliveryDate', 'DateConverter', true)
    public deliveryDate: Date = undefined;

    @JsonProperty('remarks', 'String')
    public remarks: string = undefined;

    @JsonProperty('isCustomAddressNumber', 'Boolean')
    public isCustomAddressNumber: boolean = undefined;

}
@JsonObject('PriceCalculationResultVO')
export class PriceCalculationResultVO {

    @JsonProperty('project', 'ProjectVO')
    public project: ProjectVO = undefined;

    @JsonProperty('error', '[ErrorInfoVO]')
    public error: ErrorInfoVO[] = undefined;

}
